"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotAllowed = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var NotAllowed = function NotAllowed(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'The page you are looking for does not exist.' : _ref$description,
      hideBack = _ref.hideBack;
  return react_1.default.createElement(antd_1.Result, {
    status: '403',
    title: 'Not Allowed',
    subTitle: description,
    extra: hideBack ? undefined : react_1.default.createElement(antd_1.Button, {
      type: 'primary',
      onClick: function onClick() {
        return window.history.back();
      }
    }, "Go Back")
  });
};

exports.NotAllowed = NotAllowed;